import { getIntlLocale } from './chatUiLocale'

/**
 * Best-effort display string for message timestamps from API (ISO, epoch, or opaque).
 */
export function formatMessageTimestamp(raw: unknown, locale?: string): string {
  const s = typeof raw === 'string' ? raw.trim() : ''
  if (!s) return ''
  const loc = locale || getIntlLocale()
  const d = Date.parse(s)
  if (!Number.isNaN(d)) {
    try {
      return new Intl.DateTimeFormat(loc, {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(d)
    } catch {
      return new Date(d).toLocaleString(loc)
    }
  }
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const ms = raw < 1e12 ? raw * 1000 : raw
    try {
      return new Intl.DateTimeFormat(loc, { dateStyle: 'medium', timeStyle: 'short' }).format(ms)
    } catch {
      return new Date(ms).toLocaleString(loc)
    }
  }
  return s
}
